import { render } from "./ActivityDetailBuddy.vue?vue&type=template&id=5325b32c&scoped=true"
import script from "./ActivityDetailBuddy.vue?vue&type=script&lang=js"
export * from "./ActivityDetailBuddy.vue?vue&type=script&lang=js"

import "./ActivityDetailBuddy.vue?vue&type=style&index=0&id=5325b32c&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5325b32c"]])

export default __exports__